import React from 'react';

import articlesRoutes from './articles.routes';
import equipRoutes from './equip.routes';
import financesRoutes from './finances.routes';
import hikingRoutes from './hiking.routes';
import interviewRoutes from './interview.routes';
import medicamentsRoutes from './medicaments.routes';
import obstaclesRoutes from './obstacles.routes';
import printRoutes from './print.routes';
import productsRoutes from './products.routes';
import radishRoutes from './radish.routes';
import recipesRoutes from './recipes.routes';
import rootRoutes from './root.routes';
import routesRoutes from './routes.routes';
import userRoutes from './user.routes';
import workoutsRoutes from './workouts.routes';

/**
 * Главный роутер приложения
 * работает на базе {@link https://reacttraining.com/react-router/web/guides/quick-start React router}
 */

export interface IPohodnikRouterItem {
  path: string;
  component: (props: any) => React.ReactNode;
  exact?: boolean;
  protected?: boolean;
  title?: string;
}

const allRoutes: Array<IPohodnikRouterItem> = [
  ...rootRoutes,
  ...userRoutes,
  ...routesRoutes,
  ...hikingRoutes,
  ...recipesRoutes,
  ...workoutsRoutes,
  ...obstaclesRoutes,
  ...equipRoutes,
  ...interviewRoutes,
  ...articlesRoutes,
  ...printRoutes,
  ...productsRoutes,
  ...medicamentsRoutes,
  ...radishRoutes,
  ...financesRoutes,
];

export default allRoutes;
